import React from 'react'; // eslint-disable-line

import { TextFieldProps } from '@material-ui/core/TextField';
import { Field, FieldProps } from 'react-final-form';

import { FieldSet, TextField, TextFieldTypes } from '../../';
import { MaskedInputProps } from '../text-field';

type Props = FieldProps<any, any> &
    TextFieldProps &
    MaskedInputProps & {
        type?: TextFieldTypes;
    };

export const FullWidthTextField: React.FunctionComponent<Props> = ({
    name,
    fullWidth = true,
    type = 'text',
    ...rest
}: Props) => {
    return (
        <FieldSet>
            <Field {...rest} name={name} fullWidth={fullWidth} component={TextField} type={type} />
        </FieldSet>
    );
};
